export const YES = true;
export const NO = false;

export function getLabel (type)
{
	return type === true
		? 'Ja, mit entsprechender Abgeltung'
		: 'Nein';
}
